import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import api from '~/services/api';
import { isArray } from 'lodash';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';

import ConfirmDialog from '../ConfirmDialog';

import { t } from '~/helpers';

import MyForm from './form';

const formRef = createRef();

class GPPConfirmar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      openConfirmarDialog: false,
      openRecusarDialog: false,
      params: {},
    };
  }

  //** */
  ///** processo de confirmar o Recebimento Provisório */
  handleClickConfirmar() {
    this.setState({ openConfirmarDialog: true });
  }
  handleModalConfirmarNAODialog() {
    this.setState({ openConfirmarDialog: false });
  }
  handleModalConfirmarSIMDialog() {
    this.handleConfirmarSubmit();
  }

  async handleConfirmarSubmit() {
    try {
      const prre_codigo = this.state.params.prre_codigo;
      await api.put('prerecebimento/gppconfirmar', prre_codigo);
      this.setState({ openConfirmarDialog: false });
      toast.success(t('s.geral.sucessoalteracao'));
      this.handleCloseModal();
      this.props.update();
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }
    }
  }

  //** */
  ///** processo de RECUSAR o Recebimento Provisório */
  handleClickRecusar() {
    this.setState({ openRecusarDialog: true });
  }
  handleModalRecusarNAODialog() {
    this.setState({ openRecusarDialog: false });
  }
  handleModalRecusarSIMDialog() {
    this.handleRecusarSubmit();
  }

  async handleRecusarSubmit() {
    try {
      const prre_codigo = this.state.params.prre_codigo;
      await api.put('prerecebimento/gpprecusar', prre_codigo);
      this.setState({ openRecusarDialog: false });
      toast.success(t('s.geral.sucessoalteracao'));
      this.handleCloseModal();
      this.props.update();
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }
    }
  }

  // Toggle modal
  async handleToggleModal(params = {}) {
    this.setState((prevState) => ({
      open: !prevState.open,
      params,
    }));
  }

  // Close modal
  async handleCloseModal() {
    await this.setState({ open: false });
  }

  render() {
    const { open, openConfirmarDialog, openRecusarDialog, params } = this.state;

    return (
      <>
        <Dialog
          open={open}
          maxWidth={'lg'}
          onClose={() => this.handleCloseModal()}
        >
          <DialogTitle>
            {(params.prre_status === 2) ? 'Confirmar Recebimento GP' : 'Detalhe do Recebimento Provisório'}
          </DialogTitle>
          <DialogContent>
            <MyForm
              data={params}
              reference={formRef}
              close={() => {
                this.handleCloseModal();
                this.props.update();
              }}
            />
          </DialogContent>
          <DialogActions>

            {(params.prre_status === 2) ? <Button
              startIcon={<Check />}
              color="primary"
              variant="outlined"
              disabled={params.prre_status !== 2}
              onClick={() => this.handleClickConfirmar()}
            >
              Confirmar
            </Button>
              : ''}

            {(params.prre_status === 2) ?
              <Button
                startIcon={<Check />}
                color="inherit"
                variant="outlined"
                disabled={params.prre_status !== 2}
                onClick={() => this.handleClickRecusar()}
              >
                Recusar
              </Button>
              : ''}


            <Button
              startIcon={<Close />}
              color="secondary"
              variant="outlined"
              onClick={() => this.handleCloseModal()}
            >
              {t('s.geral.botaocancelar')}
            </Button>


          </DialogActions>
        </Dialog>


        <div>
          <ConfirmDialog
            title="Confirmar Operação?"
            open={openConfirmarDialog}
            setOpen={() => this.handleModalConfirmarNAODialog()}
            onConfirm={() => this.handleModalConfirmarSIMDialog()}
          >
            Deseja confirmar o recebimento?
          </ConfirmDialog>

          <ConfirmDialog
            title="Recusar Operação?"
            open={openRecusarDialog}
            setOpen={() => this.handleModalRecusarNAODialog()}
            onConfirm={() => this.handleModalRecusarSIMDialog()}
          >
            Deseja recusar o recebimento provisório?
          </ConfirmDialog>


        </div>

      </>


    );
  }
}

export default connect(null, null, null, { forwardRef: true })(GPPConfirmar);
